import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { API_URL, getHeaders } from "../../helper/commonApi";
import { useBranding } from "../../context/BrandingContext";
import {
    EmailIconSvg,
    PasswordHideIcon,
    PasswordLockSvg,
    PasswordShowIcon,
} from "../../assets/svg/SvgComponent";

import "./loginPopup.css";

const LoginPopup = ({ onLoginSuccess }) => {
    const { portalID, colors } = useBranding();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPass, setShowPass] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

    const handleLogin = async () => {
        const validationErrors = {};
        if (!email.trim()) validationErrors.email = "Email required";
        else if (!validateEmail(email)) validationErrors.email = "Enter valid email";
        if (!password) validationErrors.password = "Password required";

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});
        setLoading(true);

        try {
            const res = await axios.post(`${API_URL}/login`, {
                portal_id: portalID,
                email,
                password,
            }, { headers: getHeaders() });

            if (res?.status === 200 || res?.status === 201) {
                const { user_id, full_name, jwt_token } = res.data.data;
                const tokenExpires = res.data.data.token_expires_in || 18000;
                const expires = new Date(Date.now() + tokenExpires * 1000).toUTCString();

                if (!res?.data?.status) {
                    setErrors({ form: res?.data?.message || "Something went wrong" });
                    return;
                }

                localStorage.setItem("_register_GRE_LOGIN_userId", user_id);
                localStorage.setItem("_register_GRE_LOGIN_full_name", full_name);
                document.cookie = `_GRE_JWT_TOKEN=${jwt_token}; expires=${expires}; path=/; Secure; SameSite=Strict`;

                toast.success("Login successful!");
                onLoginSuccess(); // call parent to continue test
            } else {
                setErrors({ form: res.data?.message || "Login failed" });
            }
        } catch (err) {
            setErrors({ form: "Login failed. Try again." });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-popup-overlay">
            <div className="login-popup">
                <h3>Login to continue your test</h3>
                {/* <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                {errors.email && <p className="error-text">{errors.email}</p>}

                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                {errors.password && <p className="error-text">{errors.password}</p>}

                {errors.form && <p className="error-text">{errors.form}</p>} */}

                <div className="">
                    <div className="input-wrapper">
                        <div className={`input-group ${errors.email ? "error" : ""}`}>
                            <EmailIconSvg />
                            <input
                                id="email"
                                name="email"
                                type="email"
                                placeholder="Enter your mail here"
                                value={email}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    setEmail(val);
                                    if (!val.trim()) {
                                        setErrors((prev) => ({ ...prev, email: "Email is required." }));
                                    } else if (!validateEmail(val)) {
                                        setErrors((prev) => ({ ...prev, email: "Enter a valid email." }));
                                    } else {
                                        setErrors((prev) => ({ ...prev, email: undefined }));
                                    }
                                }}

                            />
                        </div>
                        {errors.email && <span className="error-text">{errors.email}</span>}
                    </div>

                    <div className="input-wrapper">
                        <div className={`input-group ${errors.password ? "error" : ""}`}>
                            <PasswordLockSvg />
                            <input
                                id="password"
                                name="password"
                                type={showPass ? "text" : "password"}
                                placeholder="Password"
                                value={password}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    setPassword(val);
                                    if (val) {
                                        setErrors((prev) => ({ ...prev, password: undefined }));
                                    }
                                }}
                            />
                            <div
                                className="input-type-password-toggle"
                                onClick={() => setShowPass(!showPass)}
                            >
                                {showPass ? <PasswordShowIcon /> : <PasswordHideIcon />}
                            </div>
                        </div>
                        {errors.password && (
                            <span className="error-text">{errors.password}</span>
                        )}
                    </div>

                    {errors.form && <div className="error-text" style={{ textAlign: "center",marginLeft:"0" }}>{errors.form}</div>}

                    <button
                        className="register-btn btn black"
                        onClick={handleLogin}
                        disabled={loading}
                        style={{ backgroundColor: colors?.buttonBg }}
                    >
                        {loading ? <span className="loader-small" /> : "Login Now"}
                    </button>


                </div>

                {/* <button onClick={handleLogin} disabled={loading}>
                    {loading ? "Logging in..." : "Login"}
                </button> */}
            </div>
        </div>
    );
};

export default LoginPopup;
